import React from 'react';

const EssentialDocsPage: React.FunctionComponent<any> = () => {
  return (
    <div>
      <h3>Essential Documents Page</h3>
    </div>
  );
};

export default EssentialDocsPage;
